import { render, staticRenderFns } from "./TabelaSucursales.vue?vue&type=template&id=3d510f16&scoped=true&lang=pug"
import script from "./TabelaSucursales.vue?vue&type=script&lang=js"
export * from "./TabelaSucursales.vue?vue&type=script&lang=js"
import style0 from "./TabelaSucursales.vue?vue&type=style&index=0&id=3d510f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d510f16",
  null
  
)

export default component.exports